import { render, staticRenderFns } from "./communicationLogListing.vue?vue&type=template&id=301f8c52&"
import script from "./communicationLogListing.vue?vue&type=script&lang=js&"
export * from "./communicationLogListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports